import ImageModel from "src/Models/Form/ImageModel";

export function isImageModel(field: {[key: string]: any}): field is ImageModel {
  return (field as ImageModel).url !== undefined;
}
